import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ThemeCard } from "../components/ThemeCard";
import { allThemes } from "../modules/themes";
import { CategoryType } from "../modules/exercises.types";
import { filterThemesForProfile } from "../core/accessControl";
import { useAuth } from "../context/AuthContext";
import { MixmindUniverse, useUniverse } from "../context/UniverseContext";

// Hub principal Academy : présente les sous-rubriques et quelques thèmes éducatifs.
export default function AcademyHub() {
  const { accessProfile } = useAuth();
  const { setUniverse } = useUniverse();
  useEffect(() => {
    setUniverse(MixmindUniverse.Academy);
  }, [setUniverse]);

  const rawThemes = allThemes.filter((t) => t.category === CategoryType.COMPRENDRE);
  const themes = filterThemesForProfile(rawThemes, accessProfile);

  const sections = [
    { title: "Explorer", to: "/academy/explorer", desc: "Curiosité guidée, parcours thématiques." },
    { title: "Apprendre", to: "/academy/apprendre", desc: "Micro-cours et quiz interactifs." },
    { title: "Comprendre", to: "/academy/comprendre", desc: "Concepts clés et mises en contexte." },
    { title: "Découvrir", to: "/academy/decouvrir", desc: "Ressources pour élèves et enseignants." },
    { title: "Mon Academy", to: "/academy/dashboard", desc: "Suivi de progression et activités récentes." },
    { title: "Parcours démo", to: "/parcours/parcours-biais-confirmation-1", desc: "Parcours guidé sur le biais de confirmation." },
  ];

  return (
    <div className="max-w-6xl mx-auto space-y-8">
      <header className="space-y-2">
        <h1 className="text-3xl font-semibold text-slate-900 dark:text-white">MixMind Academy</h1>
        <p className="text-sm md:text-base text-slate-700 dark:text-slate-300">
          La rubrique pour apprendre, explorer et comprendre l&apos;intelligence mixte. Choisissez
          une entrée ou parcourez les thèmes disponibles.
        </p>
      </header>

      <section className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {sections.map((s) => (
          <Link
            key={s.to}
            to={s.to}
            className="mm-surface p-4 hover:-translate-y-0.5 hover:shadow-md transition-transform"
          >
            <h2 className="text-lg font-semibold mb-1">{s.title}</h2>
            <p className="text-sm text-slate-700 dark:text-slate-300">{s.desc}</p>
          </Link>
        ))}
      </section>

      {themes.length > 0 && (
        <section className="space-y-3">
          <h2 className="text-xl font-semibold">Thèmes recommandés</h2>
          <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {themes.map((theme) => (
              <ThemeCard key={theme.id} theme={theme} />
            ))}
          </div>
        </section>
      )}
      {themes.length === 0 && rawThemes.length > 0 && (
        <section className="space-y-2 text-sm">
          <h3 className="text-lg font-semibold">Aucun thème affiché pour ce profil</h3>
          <p className="text-slate-700 dark:text-slate-300">
            Tous les contenus restent disponibles en mode découverte. Ajustez le profil ou la tranche
            d&apos;âge ultérieurement.
          </p>
          {/* TODO MixMind: proposer un sélecteur d'âge/rôle depuis le compte pour prévisualiser l'accès. */}
        </section>
      )}
    </div>
  );
}
